export type PaletteItem = {
  id: string;
  label: string;
  hint?: string;
  href: string;
  keywords?: string;
};

// Scores a query against text: prefix > word start > substring > subsequence.
// Returns -1 when it does not match.
export function matchScore(query: string, text: string): number {
  const q = query.trim().toLowerCase();
  if (!q) return 0;
  const t = text.toLowerCase();
  if (t.startsWith(q)) return 100 - Math.min(t.length, 50) / 100;
  const word = t.search(new RegExp(`(^|[\\s/._-])${q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`));
  if (word >= 0) return 80 - Math.min(word, 50) / 100;
  const at = t.indexOf(q);
  if (at >= 0) return 60 - Math.min(at, 50) / 100;
  let i = 0;
  for (const ch of t) if (ch === q[i] && ++i === q.length) return 20;
  return -1;
}

export function rankItems(items: PaletteItem[], query: string, limit = 30): PaletteItem[] {
  if (!query.trim()) return items.slice(0, limit);
  return items
    .map((item) => {
      const scores = [matchScore(query, item.label), matchScore(query, `${item.hint ?? ""} ${item.keywords ?? ""}`) - 15];
      return { item, score: Math.max(...scores) };
    })
    .filter((entry) => entry.score >= 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, limit)
    .map((entry) => entry.item);
}
